import { FaqContent } from '@/app/[locale]/account/faq/_components/content'
import { useTranslations } from 'next-intl'

export const CoolClubFaq = () => {
  const t = useTranslations()
  return (
    <div className='bg-neutral-100 px-4 py-10'>
      <div className='mx-auto max-w-[1300px]'>
        <h2 className='mb-5 font-criteria text-2xl font-semibold leading-9 text-neutral-900 lg:mb-6 lg:text-center lg:text-[44p]'>
          {t('landing_coolclub_page.faq.title')}
        </h2>
        <FaqContent className='bg-light' />
      </div>
    </div>
  )
}
